import { STATUS_LABELS, STATUS_TONES } from "@/lib/constants";

const TONE_CLS = {
    green: "bg-emerald-50 text-emerald-700 border-emerald-200",
    blue: "bg-blue-50 text-blue-700 border-blue-200",
    amber: "bg-amber-50 text-amber-700 border-amber-200",
    red: "bg-rose-50 text-rose-700 border-rose-200",
    grey: "bg-zinc-100 text-zinc-700 border-zinc-200",
};

export default function StatusBadge({ status, tone, label, className = "", testId }) {
    const t = tone || STATUS_TONES[status] || "grey";
    const text = label || STATUS_LABELS[status] || status;
    return (
        <span
            data-testid={testId}
            className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-medium ${TONE_CLS[t]} ${className}`}
        >
            <span className={`h-1.5 w-1.5 rounded-full ${
                t === "green" ? "bg-emerald-500" : t === "blue" ? "bg-blue-500" : t === "amber" ? "bg-amber-500" : t === "red" ? "bg-rose-500" : "bg-zinc-500"
            }`} />
            {text}
        </span>
    );
}
